import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class LoaderFullService {
  loading = false

  isPleaseWaite1 = false
  isPleaseWaite2 = false
  isPleaseWaite3 = false

  loading$: BehaviorSubject<boolean> = new BehaviorSubject(false)

  constructor() {}

  setLoading(bool: boolean) {
    this.loading = bool
    this.loading$.next(bool)

    if ((this.loading = true)) {
      setTimeout(() => {
        if (this.loading) {
          this.isPleaseWaite1 = true
          setTimeout(() => {
            if (this.loading) {
              this.isPleaseWaite2 = true
              setTimeout(() => {
                if (this.loading) this.isPleaseWaite3 = true
              }, 1500)
            }
          }, 1500)
        }
      }, 1500)
    } else {
      this.isPleaseWaite1 = false
      this.isPleaseWaite2 = false
      this.isPleaseWaite3 = false
    }
  }
}
